module.exports = "/assets/data/fbc7e3b5eccfc36dec1d8210a4fc6a64-SA39.data.json";